"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventNames = void 0;
exports.EventNames = {
    CONTACT_LINK_CLICKED: "Contact Link Clicked",
    CTA_CLICKED: "CTA Clicked",
    EXPERIMENT_VIEWED: "Experiment Viewed",
    FACILITY_LIST_VIEWED: "Facility List Viewed",
    FACILITY_MOVE_IN_CONFIRMED: "Facility Move in Confirmed",
    FACILITY_UNIT_SELECTED: "Facility Unit Selected",
    FACILITY_VIEWED: "Facility Viewed",
    FORM_SUBMITTED: "Form Submitted",
    ONLINE_MOVE_IN_COMPLETED: "Online Move-In Completed",
    ONLINE_MOVE_IN_STARTED: "Online Move-In Started",
    ONLINE_MOVE_IN_STEP_VIEWED: "Online Move-In Step Viewed",
    OUTBOUND_LINK_CLICKED: "Outbound Link Clicked",
    PAGE_VIEWED: "Page Viewed",
    RESERVATION_COMPLETED: "Reservation Completed",
    RESERVATION_STARTED: "Reservation Started",
    SEARCH_FILTERED: "Search Filtered",
    SEARCH_SUBMITTED: "Search Submitted",
    VIDEO_WATCHED: "Video Watched",
};
//# sourceMappingURL=event-names.js.map